import React from 'react'

interface Props {
  time: number
}

const NiceDate: React.FC<Props> = props => {
  const obj = new Date(props.time || 0)

  const year = obj.getFullYear();
  const month = "0" + (obj.getMonth() + 1);
  const day = "0" + obj.getDate();

  const hours = obj.getHours();
  // Minutes part from the timestamp
  const minutes = "0" + obj.getMinutes();
  // Seconds part from the timestamp
  // const seconds = "0" + obj.getSeconds();

  const date = year + '-' + month.substr(-2) + '-' + day.substr(-2)

  const time = hours + ':' + minutes.substr(-2) // + ':' + seconds.substr(-2);

  return (
    <span>
      {date} {time}
    </span>
  )
}

export default NiceDate
